import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = "Privacy Policy | Digital Media Ninja";
  }, []);

  return (
    <div className="min-h-screen pt-32 pb-20" data-testid="privacy-policy-page">
      <Helmet>
        <title>Privacy Policy | Digital Media Ninja</title>
        <meta name="description" content="Digital Media Ninja privacy policy. Learn how we collect, use, and protect your personal information." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://digitalmedianinja.com/privacy-policy" />
      </Helmet>

      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
          <p className="text-gray-400 mb-8">Last Updated: February 4, 2026</p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                Digital Media Ninja ("we," "our," or "us") collects information you provide directly to us, including:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2">
                <li>Contact information (name, email address, phone number, company name)</li>
                <li>Business information relevant to marketing services</li>
                <li>Communications you send to us</li>
                <li>Information provided when downloading guides or resources</li>
                <li>Survey responses and feedback</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">2. Automatic Information Collection</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                When you visit our website, we automatically collect certain information, including:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2">
                <li>IP address and device information</li>
                <li>Browser type and version</li>
                <li>Pages visited and time spent on pages</li>
                <li>Referring website or source</li>
                <li>Geographic location (country/city level)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">3. How We Use Your Information</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We use the information we collect to:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2">
                <li>Provide, maintain, and improve our services</li>
                <li>Send marketing communications (with your consent)</li>
                <li>Respond to your comments, questions, and requests</li>
                <li>Analyze website usage and improve user experience</li>
                <li>Protect against fraudulent or illegal activity</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">4. Information Sharing</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We do not sell your personal information. We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2">
                <li>Service providers who assist in our operations (e.g., HubSpot, Stripe)</li>
                <li>Professional advisors as required by law</li>
                <li>Law enforcement when required by legal process</li>
                <li>Business partners with your consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">5. Cookies and Tracking</h2>
              <p className="text-gray-300 leading-relaxed">
                We use cookies and similar tracking technologies to collect information about your browsing activities. You can control cookies through your browser settings. We use HubSpot for analytics and marketing automation, Google Analytics for website analytics, and similar tools to improve our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">6. Data Security</h2>
              <p className="text-gray-300 leading-relaxed">
                We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">7. Your Rights</h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                You have the right to:
              </p>
              <ul className="list-disc pl-6 text-gray-300 space-y-2">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt-out of marketing communications</li>
                <li>Withdraw consent at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">8. Contact Us</h2>
              <p className="text-gray-300 leading-relaxed">
                If you have questions about this Privacy Policy, please contact us at:
              </p>
              <div className="mt-4 p-4 bg-white/5 rounded-xl border border-white/10">
                <p className="text-white">Digital Media Ninja</p>
                <p className="text-gray-400">3333 Harry Hines Blvd, Dallas, TX 75201</p>
                <p className="text-gray-400">Email: info@digitalmedianinja.com</p>
                <p className="text-gray-400">Phone: (432) 934-9470</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
